export default __webpack_public_path__ + "static/media/planeta.15dc8ec3.svg";